<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Bill Date</th>
                    <th>Bill NO</th>
                    <th class="text-right">Bill Amount</th>
                    <th class="text-center">VDS</th>
                    <th class="text-center">TDS</th>
                    <th class="text-center">Discount</th>
                    <th class="text-right">Already Paid</th>
                    <th class="text-right">Already Adjusted</th>
                    <th class="text-right">Due</th>
                    <th class="text-right">Payment</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, i) in payBills" :key="i">
                    <BillPayTableRow :item="item" :isDisabled="isDisabled" />
                </template>
                </tbody>
                <tfoot v-if="payBills.length">
                <tr>
                    <th colspan="2" class="text-left">Total</th>
                    <th class="text-right">{{ commaFormat(totalBillAmount) }}</th>
                    <th class="text-right">{{ commaFormat(totalVds) }}</th>
                    <th class="text-right">{{ commaFormat(totalTds) }}</th>
                    <th class="text-right">{{ commaFormat(totalDiscount) }}</th>
                    <th class="text-right">{{ commaFormat(totalPaid) }}</th>
                    <th class="text-right">{{ commaFormat(totalAdjusted) }}</th>
                    <th class="text-right">{{ commaFormat(totalDue) }}</th>
                    <th class="text-right">{{ commaFormat(total) }}</th>
                </tr>
                </tfoot>
            </table>
            <!-- <p v-if="!purchase.length" class="text-center mt-5">No data</p> -->
        </div>
    </div>
</template>

<script setup>
import BillPayTableRow from '@/components/molecule/company/inventory/purchase/BillPayTableRow.vue'
    import { computed, watch } from 'vue'
    import figureFormatter from '@/services/utils/figureFormatter'
    const emits = defineEmits(['updateTotal']);
    const props = defineProps({
        payBills: Array,
        isDisabled: {
            type: Boolean,
            default: false
        }
    })
    const {commaFormat} = figureFormatter()

    const sumOf = (key) => {
        return props.payBills.reduce((carry, item) => {
            const value = parseFloat(item[key])
            if (isNaN(value)) return carry
            return carry + value
        }, 0)
    }

    const totalBillAmount = computed(() => sumOf('total_amount'))
    const totalVds = computed(() => sumOf('vds_payable_amount'))
    const totalTds = computed(() => sumOf('tds_payable_amount'))
    const totalDiscount = computed(() => sumOf('discount_receipt_amount'))
    const totalPaid = computed(() => sumOf('paid_amount'))
    const totalAdjusted = computed(() => sumOf('adjustment_amount'))
    const totalDue = computed(() => sumOf('due'))

    const total = computed(() => sumOf('payment'))

    watch(total, (totalAmount) => {
        emits('updateTotal', totalAmount)
    }, { immediate: true })
</script>
